import { axios } from "../../lib/axios"

export const DeleteStaff = (id: number) => {
  return axios.delete(`/api/v1/user/delete/${id}`)
}
